export function formatPrice(cents: number | null, currency: string | null, free: boolean): string {
  if (free) return "Free";
  if (cents == null || currency == null) return "—";
  const amount = cents / 100;
  try {
    return new Intl.NumberFormat("en", { style: "currency", currency }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}
